import { supabase } from "./supabaseClient";

export async function getUserCredits(userId) {
  if (!userId) return 0;

  const { data, error } = await supabase
    .from("users")
    .select("credits")
    .eq("id", userId)

  if (error) {
    console.error("Error getting user credits:", error.message);
    return 0;
  }
  return data[0].credits;
}


export async function getUserHistory(userId) {
  if (!userId) return 0;

  const { data, error } = await supabase
    .from("users")
    .select("history")
    .eq("id", userId)

  if (error) {
    console.error("Error getting user history:", error.message);
    return [];
  }
  return data[0].history;
}